import { combineReducers } from "@reduxjs/toolkit";

export const rootReducer = combineReducers({});

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootState {}
